import gql from 'graphql-tag';
import {
  CatalogItemCardFragment,
  MostUsefulCommentFragment,
  PromocodeGiftItemsFragment,
  MultiPricesFragment,
  CatalogTasksItemsFragment
} from '../fragments/fragments.cartEndpoint';

const ProductInfoQuery = {
  getProductAlsoboughtAndRecommend: gql`
    query getProductAlsoboughtAndRecommend(
      $productId: Int!
      $cartToken: String
      $isMenu: Boolean!
      $menuStoreId: Int
    ) {
      getProductAlsoboughtAndRecommend(
        productId: $productId
        cartToken: $cartToken
        isMenu: $isMenu
        menuStoreId: $menuStoreId
      ) {
        # рекомендуемые товары
        recommendations {
          ...CatalogItemCardFragment
        }
        # с этим товаром покупают
        alsobought {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getCatalogAnalogs: gql`
    query getCatalogAnalogs($catalogId: Int, $epp: Int) {
      getCatalogAnalogs(catalogId: $catalogId, epp: $epp) {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getProductInfoTemp: gql`
    query getProductInfoTemp(
      $id: Int!
      $isMenu: Boolean!
      $menuStoreId: Int
      $cartToken: String
    ) {
      availableForRefund(catalogId: $id)
      getProductByIdTemp(
        id: $id
        isMenu: $isMenu
        menuStoreId: $menuStoreId
        cartToken: $cartToken
        isPrepareVideoFromText: true
      ) {
        id
        is_18plus
        isMenu
        is_not_for_sale
        is_our
        title
        digital
        how_to_make
        ...MultiPricesFragment
        ...CatalogTasksItemsFragment
        subtitle
        expiration_title
        supply_title
        videoFromText
        digital
        supplier_id
        status_id
        is_natural
        war_id
        measure_id
        isExpressDeliveryAval
        redirect
        getURL
        productDiscountNotification
        archive
        ...PromocodeGiftItemsFragment
        isExpressPickupAval
        carbs
        fats
        reference_weight
        proteins
        videos {
          id
          url
          title
          thumbnail_url
          thumbnail_height
          thumbnail_width
        }
        variants {
          id
          weight_of_goods
          sizeRangeItem {
            id
            title
            type_name
            type_measure
          }
        }

        specialPriceData {
          amount
          price
          weight
          price1Kg
        }

        mainRootRubric {
          id
          title
          shortTitle
          short_title
          identify
        }

        bread {
          title
          link
          binding
        }
        sizeRangeItem {
          id
          title
        }
        currentPriceField2 # текущая цена нижнего блока
        symbolPriceField2 # мера веса нижнего блока
        oldPriceField2 # старая цена нижнего блока
        priceBlockWeightPrice

        averageRating # средний рейтинг для отзывов
        mostUsefulComment {
          ...MostUsefulCommentFragment
        }

        delivery {
          date
          date_with_timezone
          is_nearest
        }

        isFavorite
        available
        hit
        price_retail
        price_active
        title
        weight_of_goods
        subtitle
        sales_number
        rating_comments
        comments_number
        active
        vesovoi
        gds_count
        oldPriceField
        discounPriceField
        currentPriceField
        symbolPriceField

        measureItem {
          weight
          term
          symbol
        }
        country
        countryOfOrigin @skip(if: $isMenu)
        attributes @skip(if: $isMenu) {
          code
          title
          type
          value
          number
          bool
          unitCode
          unitText
        }
        title_en
        package
        storage_conditions
        nutritional_value
        energy_value
        ingredients
        gost
        registryRecordUrls
        text
        seo_md
        badgesList {
          id
          title
          identify
          color
        }
        badges {
          newbee {
            available
            link
          }
          hit {
            available
            link
          }
          discount {
            available
            link
          }
          promotion {
            available
            link
            title
          }
          superprice {
            available
            link
          }
          natural {
            available
            link
          }
        }

        isBigCard
        images {
          small
          big
          square
          original
          raw
        }
        availableQuantity {
          store_id
          amount
        }
      }
    }
    ${CatalogTasksItemsFragment}
    ${MostUsefulCommentFragment}
    ${PromocodeGiftItemsFragment}
    ${MultiPricesFragment}
  `,

  getProductRecipes: gql`
    query getProductRecipesById($id: Int!) {
      getProductRecipesById(catalogId: $id) {
        totalCount
        recipeItems {
          id
          cooking_time
          rating
          isFavorite
          serving
          comments_number
          title
          attachmentsItem {
            cacheItem {
              filePath
            }
          }
          identifyIdURI
          bludoItem {
            title
          }
        }
      }
    }
  `,
  getPromoRecipesByProductId: gql`
    query getPromoRecipesByProductId($productId: Int!) {
      getPromoRecipesByProductId(
        productId: $productId
        imageSizeFilter: "w480"
      ) {
        id
        cooking_time
        rating
        isFavorite
        serving
        comments_number
        video_code
        title
        attachmentsItem {
          cacheItem {
            filePath
          }
        }
        identifyIdURI
        bludoItem {
          title
        }
        recipeIngredients {
          id
          title
          value
          ##!! Всегда брать первый элемент !!##
          ingredientsItems {
            catalogItem {
              id
              available
              currentPriceField
              currentPriceField2
              symbolPriceField
              symbolPriceField2
              gds_count
              ## catalogItem('list')
            }
          }
        }
        extraPrice
      }
    }
  `,
  getProductQuickInfo: gql`
    query getProductQuickInfo($catalogId: Int!) {
      getProductByIdTemp(id: $catalogId, isPrepareVideoFromText: true) {
        id
        title
        subtitle
        carbs
        fats
        proteins
        reference_weight
        digital
        isMenu
        is_not_for_sale
        #videoFromText
        #supplier_id
        war_id
        status_id
        ...MultiPricesFragment
        is_natural
        #redirect
        #getURL
        productDiscountNotification
        archive
        isExpressPickupAval
        isExpressDeliveryAval
        badgesList {
          id
          title
          identify
          color
        }
        is_our
        #variants {
        #  id
        #  weight_of_goods
        #  sizeRangeItem {
        #   id
        #    title
        #    sort
        #    type_name
        #  type_measure
        #  }
        #}
        #bread {
        #  title
        #  link
        #  binding
        #}
        ...PromocodeGiftItemsFragment
        sizeRangeItem {
          id
          title
        }
        specialPriceData {
          amount
          price
          weight
          price1Kg
        }
        currentPriceField2 # текущая цена нижнего блока
        symbolPriceField2 # мера веса нижнего блока
        oldPriceField2 # старая цена нижнего блока
        priceBlockWeightPrice

        averageRating # средний рейтинг для отзывов
        mostUsefulComment {
          ...MostUsefulCommentFragment
        }

        #delivery {
        #  date
        #  is_nearest
        #}

        isFavorite
        available
        hit
        price_retail
        price_active
        title
        weight_of_goods
        subtitle
        sales_number
        rating_comments
        comments_number
        active
        vesovoi
        gds_count
        oldPriceField
        discounPriceField
        currentPriceField
        symbolPriceField

        measureItem {
          weight
          term
          symbol
        }
        country
        title_en
        #package
        #expiration_date
        storage_conditions
        nutritional_value
        energy_value
        ingredients
        gost
        text
        seo_md

        badges {
          newbee {
            available
            link
          }
          hit {
            available
            link
          }
          discount {
            available
            link
          }
          promotion {
            available
            link
            title
          }
          superprice {
            available
            link
          }
          natural {
            available
            link
          }
        }

        #isBigCard
        images {
          small
          big
          square
          original
          raw
        }
      }
    }
    ${MostUsefulCommentFragment}
    ${PromocodeGiftItemsFragment}
    ${MultiPricesFragment}
  `,

  getRecommendationsToCart: gql`
    query getRecommendationsToCart($orderId: Float, $cartToken: String!) {
      getRecommendationsToCart(orderId: $orderId, cartToken: $cartToken) {
        totalCount
        title
        items {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getRecommendationsToOrder: gql`
    query getRecommendationsToOrder($cartToken: String, $orderId: Float) {
      getRecommendationsToCart(cartToken: $cartToken, orderId: $orderId) {
        totalCount
        title
        items {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getRefundInfo: gql`
    query getRefundInfo($orderItemId: Int, $productId: Int!) {
      refundCommentsList {
        id
        text
      }
      refundPaymentType {
        id
        title
        comment
      }
      productRefundStats(catalogId: $productId, orderItemId: $orderItemId) {
        peoplePurchasedProductPrice
        maxRefundDays
        maxRefundAmount
        itemsData {
          id
          price
          item_weight
          item_amount
        }
        activeRefunds {
          id
          order_id
          order_item_id
          orderItem {
            id
            catalog_id
            amount
            price
          }
          order {
            id
            price
          }
          amount
          total
          comment
          refund_type_id
          type {
            id
            title
            comment
          }
          date

          photos {
            id
            thumb
            big
            isVideo
            video {
              title
              file
              width
              height
              converted
            }
          }
          commentItems {
            id
            text
            weight
            active
          }
        }
      }
    }
  `,
  getProductsBySupplierId: gql`
    query getProductsBySupplierId(
      $supplierId: Int!
      $setLimit: Int
      $page: Int
      $imageSizeFilter: String
      $setOrder: String
      $specOffer: String
      $withUserSettings: Boolean
    ) {
      getProductsBySupplierId(
        supplierId: $supplierId
        setLimit: $setLimit
        page: $page
        imageSizeFilter: $imageSizeFilter
        setOrder: $setOrder
        specOffer: $specOffer
        withUserSettings: $withUserSettings
      ) {
        totalCount
        catalogItem {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getRecommendedByStore: gql`
    query getRecommendedByStore(
      $storeId: Int!
      $cartToken: String
      $productsLimit: Int!
    ) {
      getRecommendedByStore(
        storeId: $storeId
        cartToken: $cartToken
        productsLimit: $productsLimit
      ) {
        totalCount
        catalogItems {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `
};

export default ProductInfoQuery;
